import React from "react";
import PageSection from "../section";
import GridMainLayout from "../../../widgets/grid";
import { Grid } from "@mui/material";

export default function PageContent({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <PageSection>
      <GridMainLayout>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>{children}</Grid>
      </GridMainLayout>
    </PageSection>
  );
}
